import React, { FC } from 'react';
import {useTranslation} from "react-i18next";

interface ProgressBarProps {
    progress: number | undefined;
}

const ProgressBar: FC<ProgressBarProps> = ({progress}) => {
    const { t } = useTranslation();

    return (
        <div className="progress-bar-wrapper">
            <div className='percent-status'>{t('gpsr:filling_progress', {progress})}</div>
            <div className="progress-bar">
                <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
            </div>
        </div>
    );
};

export default ProgressBar;